import { OmegaIcon } from './OmegaIcon';

/**
 * author: Austin Andrews
 * id A98F63CB-AB27-4A2D-B76C-6994507BCDBB
 * name omega
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/omega.svg
 * tags
 */
export const OhmIcon = OmegaIcon;
export default OhmIcon